import { Component, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'palomaCallejaMartinez';
  faChevronUp = faChevronUp;
  inicio:boolean;
  sobreMi:boolean;
  metodoTrabajo:boolean;
  areasIntervencion:boolean;
  talleres:boolean;
  contacto:boolean;
  psicoanecdotas:boolean;

  constructor(@Inject(DOCUMENT) private document: Document, private router:Router) { 
    this.optionSelect("inicio");
  }

  optionSelect(event: string){
    this.inicio = (event=="inicio")?true:false;
    this.sobreMi = (event=="sobreMi")?true:false;
    this.metodoTrabajo = (event=="metodoTrabajo")?true:false;
    this.areasIntervencion = (event=="areasIntervencion")?true:false;
    this.talleres = (event=="talleres")?true:false;
    this.contacto = (event=="contacto")?true:false;
    this.psicoanecdotas = (event=="psicoanecdotas")?true:false;
    if (event=="inicio") document.documentElement.scrollTop = 0;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if(!this.psicoanecdotas && !this.contacto){
      if (document.documentElement.scrollTop < 1064) {
        this.inicio = true;
        this.sobreMi = false;
        this.metodoTrabajo = false;
        this.areasIntervencion = false;
        this.talleres = false;
      }
      if (document.documentElement.scrollTop > 1064 && document.documentElement.scrollTop < 2200) {
        this.inicio = false;
        this.sobreMi = true;
        this.metodoTrabajo = false;
        this.areasIntervencion = false;
        this.talleres = false;
      }
      if (document.documentElement.scrollTop > 2200 && document.documentElement.scrollTop < 3750) {
        this.inicio = false;
        this.sobreMi = false;
        this.metodoTrabajo = true;
        this.areasIntervencion = false;
        this.talleres = false;
      }
      if (document.documentElement.scrollTop > 3750 && document.documentElement.scrollTop < 6400) {
        this.inicio = false;
        this.sobreMi = false;
        this.metodoTrabajo = false;
        this.areasIntervencion = true;
        this.talleres = false;
      }
      if (document.documentElement.scrollTop > 6400 && document.documentElement.scrollTop < 8500) {
        this.inicio = false;
        this.sobreMi = false;
        this.metodoTrabajo = false;
        this.areasIntervencion = false;
        this.talleres = true;
      }
    }
  }
}
